import { Button } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import img from "../../assets/images/empty.png";
import MessagePanel from "../../components/messagePanel";
import RaksDrawer from "../../components/raksDrawer";
import { uzytkownicyActions } from "../../store/actions/uzytkownicy.actions";
import { IDRaksStore } from "../../store/store";
import {
  OrganizacjaWidok,
  RolaUzytkownika,
} from "../../store/types/organizacje";
import { UzytkownikWidok } from "../../store/types/uzytkownicy";
import { UzytkownicyPageStyle } from "../../styles/UzytkownicyPageStyle";
import UzytkownicyEdycja from "./uzytkownicy.edycja";
import UzytkownikElement from "./uzytkownik.element";

interface UzytkownicyPageProps {
  error: string;
  lista: UzytkownikWidok[];
  onPrzegladaj: Function;
  onUsun: Function;
  organizacja: OrganizacjaWidok;
}

const UzytkownicyPage = (props: UzytkownicyPageProps) => {
  const { error, onPrzegladaj, lista, organizacja, onUsun } = props;

  const [isDrawer, setIsDrawer] = useState(false);
  const [edytowany, setEdytowany] = useState("");
  const [wlasciciel, setWlasciciel] = useState({} as UzytkownikWidok);
  const [pobranoDane, setPobranoDane] = useState(false);

  useEffect(() => {
    if (organizacja.Id)
      onPrzegladaj(organizacja.Id).then(() => setPobranoDane(true));
    // eslint-disable-next-line
  }, [organizacja]);

  useEffect(() => {
    if (lista && lista.length > 0)
      setWlasciciel(
        lista.filter((x) => x.Rola === RolaUzytkownika.Wlasciciel)[0]
      );
  }, [lista]);

  function onSave() {
    onPrzegladaj(organizacja.Id);
  }

  function edytuj(idZaproszenia: string) {
    setEdytowany(idZaproszenia);
    setIsDrawer(true);
  }

  function usun(idZaproszenia: string) {
    onUsun(organizacja.Id, idZaproszenia).then(() => {
      onPrzegladaj(organizacja.Id);
    });
  }

  return (
    <UzytkownicyPageStyle>
      <header>
        <h5>Użytkownicy</h5>
        <Button
          name="btnZapisz"
          color="secondary"
          variant="contained"
          onClick={() => {
            setEdytowany("");
            setIsDrawer(true);
          }}
        >
          ZAPROŚ UŻYTKOWNIKA
        </Button>
      </header>
      {error ? (
        <MessagePanel title="Błąd" mode="error" message={error} />
      ) : (
        <div />
      )}
      {lista.length > 0 ? (
        <section>
          <div className="title disabled caption">
            <span>IMIĘ NAZWISKO</span>
            <span>E-MAIL</span>
            <span>ROLA</span>
            <span>STATUS</span>
          </div>
          <div>
            <UzytkownikElement
              element={wlasciciel}
              onEdit={() => edytuj(wlasciciel.IdZaproszenia)}
              onDelete={() => usun(wlasciciel.IdZaproszenia)}
            />
            {lista
              .filter((x) => x.Rola !== RolaUzytkownika.Wlasciciel)
              .map((u, i) => (
                <UzytkownikElement
                  key={i}
                  element={u}
                  onEdit={() => edytuj(u.IdZaproszenia)}
                  onDelete={() => usun(u.IdZaproszenia)}
                />
              ))}
          </div>
        </section>
      ) : pobranoDane ? (
        <div className="empty">
          <img src={img} alt="logo" />
          <h4>W tej organizacji nie ma jeszcze żadnych użytkowników</h4>
        </div>
      ) : (
        <div />
      )}
      <RaksDrawer
        isOpen={isDrawer}
        onCancel={() => setIsDrawer(false)}
        withExitEvent
      >
        <UzytkownicyEdycja onSaveAction={onSave} edytowany={edytowany} />
      </RaksDrawer>
    </UzytkownicyPageStyle>
  );
};

function mapStateToProps(store: IDRaksStore) {
  return {
    error: store.uzytkownicy.browseError,
    lista: store.uzytkownicy.lista,
    organizacja: store.organizacje.wybrana,
  };
}

function mapDispatchToProps(dispatch: Function) {
  return {
    onPrzegladaj: (idOrg: string) =>
      dispatch(uzytkownicyActions.przegladaj(idOrg)),
    onUsun: (idOrg: string, idZapr: string) =>
      dispatch(uzytkownicyActions.usun(idOrg, idZapr)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(UzytkownicyPage);
